module.exports = __webpack_public_path__ + "img/bivKTeNv.58c07750.svg";